import { render, staticRenderFns } from "./PaiemFourRetard.vue?vue&type=template&id=0b5a1e66&scoped=true&"
import script from "./PaiemFourRetard.vue?vue&type=script&lang=js&"
export * from "./PaiemFourRetard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5a1e66",
  null
  
)

export default component.exports